import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgApexchartsModule} from 'ng-apexcharts';
import {PatientWeeklyAdherenceV2, CarerWeeklyAdherence} from '@shared/api/models/query/patient-weekly-snapshot.model';
import {ChartOptions} from '@shared/chart/chart-options';

@Component({
    selector: 'cdss-weekly-adherence-donuts',
    standalone: true,
    imports: [CommonModule, NgApexchartsModule],
    templateUrl: './weekly-adherence-donuts.component.html',
    styleUrl: './weekly-adherence-donuts.component.scss'
})
export class WeeklyAdherenceDonutsComponent {

    @Input() adherence: PatientWeeklyAdherenceV2 | CarerWeeklyAdherence | null = null;
    @Input() type: 'patient' | 'carer' = 'patient';

    chartOptions: Partial<ChartOptions> = {
        nonAxisSeries: [],
        chart: {
            type: 'pie',
            width: 90,
            height: 64,
            animations: {enabled: false},
            selection: {enabled: false},
            events: {click: () => {}}
        },
        colors: ['rgba(95, 203, 137, 1)', 'rgba(229, 246, 236, 1)'],
        legend: {show: false},
        dataLabels: {enabled: false},
        tooltip: {enabled: false},
        states: {
            hover: {filter: {type: 'none'}},
            active: {filter: {type: 'none'}}
        }
    };

    get chapterPct(): number {
        if (!this.adherence || this.adherence.chapters.scheduled === 0) return 0;
        return Math.round(this.adherence.chapters.completed * 100 / this.adherence.chapters.scheduled);
    }

    get checkInPct(): number {
        if (!this.adherence || this.adherence.checkIns.scheduled === 0) return 0;
        return Math.round(this.adherence.checkIns.completed * 100 / this.adherence.checkIns.scheduled);
    }

    get foodDiaryPct(): number {
        const pa = this.adherence as PatientWeeklyAdherenceV2;
        if (!pa?.foodDiary || pa.foodDiary.scheduled === 0) return 0;
        return Math.round(pa.foodDiary.completed * 100 / pa.foodDiary.scheduled);
    }

    get isPatient(): boolean {
        return this.type === 'patient';
    }

    get chapterSerie(): number[] {
        return [this.chapterPct, 100 - this.chapterPct];
    }

    get checkInSerie(): number[] {
        return [this.checkInPct, 100 - this.checkInPct];
    }

    get foodDiarySerie(): number[] {
        return [this.foodDiaryPct, 100 - this.foodDiaryPct];
    }
}
